import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Ambient Fingerprinting made the fingerprinting process incredibly smooth and convenient. Their mobile service came right to my office, saving me valuable time. Highly recommended!',
    author: 'John D.',
    role: 'Business Owner'
  }, {
    quote: "As a caregiver, safety is my top priority. Ambient Fingerprinting's adult dependent care fingerprinting service gave me peace of mind knowing that my loved ones are in good hands. Thank you for your professionalism and efficiency!",
    author: 'Sarah W.',
    role: 'Caregiver'
  }];
  const [activeIndex, setActiveIndex] = useState(0);
  return <section className="py-24 bg-[#DBE2F5]" aria-labelledby="testimonials-heading" data-id="element-216">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-217">
        <div className="text-center mb-16" data-id="element-218">
          <h2 id="testimonials-heading" className="text-3xl md:text-4xl font-bold text-[#1E1F55] mb-4" data-id="element-219">
            What Our Clients Say
          </h2>
          <div className="w-24 h-1 bg-[#4AA6CF] mx-auto rounded-full" aria-hidden="true" data-id="element-220"></div>
        </div>

        {/* Desktop View (Grid) */}
        <div className="hidden md:grid grid-cols-2 gap-8" data-id="element-221">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white/60 backdrop-blur-sm rounded-2xl p-8 shadow-sm border border-white" data-id="element-222">
              <QuoteIcon className="h-10 w-10 text-[#4AA6CF]/40 mb-4" aria-hidden="true" data-id="element-223" />
              <blockquote data-id="element-224">
                <p className="text-gray-800 text-lg leading-relaxed mb-8 font-medium italic" data-id="element-225">
                  "{testimonial.quote}"
                </p>
                <footer data-id="element-226">
                  <cite className="not-italic" data-id="element-227">
                    <span className="font-bold text-[#1E1F55] block" data-id="element-228">
                      {testimonial.author}
                    </span>
                    <span className="text-sm text-gray-600" data-id="element-229">
                      {testimonial.role}
                    </span>
                  </cite>
                </footer>
              </blockquote>
            </motion.div>)}
        </div>

        {/* Mobile View (Carousel) */}
        <div className="md:hidden relative" aria-live="polite" aria-atomic="true" data-id="element-230">
          <AnimatePresence mode="wait" data-id="element-231">
            <motion.div key={activeIndex} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.3
          }} className="bg-white/60 backdrop-blur-sm rounded-2xl p-8 shadow-sm border border-white" data-id="element-232">
              <QuoteIcon className="h-10 w-10 text-[#4AA6CF]/40 mb-4" aria-hidden="true" data-id="element-233" />
              <blockquote data-id="element-234">
                <p className="text-gray-800 text-lg leading-relaxed mb-8 font-medium italic" data-id="element-235">
                  "{testimonials[activeIndex].quote}"
                </p>
                <footer data-id="element-236">
                  <cite className="not-italic" data-id="element-237">
                    <span className="font-bold text-[#1E1F55] block" data-id="element-238">
                      {testimonials[activeIndex].author}
                    </span>
                    <span className="text-sm text-gray-600" data-id="element-239">
                      {testimonials[activeIndex].role}
                    </span>
                  </cite>
                </footer>
              </blockquote>
            </motion.div>
          </AnimatePresence>

          <div className="flex justify-center gap-2 mt-8" role="tablist" aria-label="Testimonial navigation" data-id="element-240">
            {testimonials.map((_, index) => <button key={index} role="tab" aria-selected={index === activeIndex} onClick={() => setActiveIndex(index)} className={`w-2.5 h-2.5 rounded-full transition-colors ${index === activeIndex ? 'bg-[#1E1F55]' : 'bg-[#1E1F55]/20'}`} aria-label={`Show testimonial ${index + 1} of ${testimonials.length}`} data-id="element-241" />)}
          </div>
        </div>
      </div>
    </section>;
}